import { formatProductPrice } from '@/app/(layout)/[serviceUrl]/_utils/productPrice'
import { Minus, Plus } from 'lucide-react'

interface IProductParticipantCounterProps {
  label: string
  price: string | null
  value: number
  min: number
  max?: number
  onChange: (value: number) => void
}

export default function ProductParticipantCounter({
  label,
  price,
  value,
  min,
  max,
  onChange,
}: IProductParticipantCounterProps) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <p className="text-sm font-semibold">{label}</p>
        <p className="mt-1 text-xs text-gray-400">{formatProductPrice(price, '원')} / 1인</p>
      </div>
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={() => {
            onChange(Math.max(min, value - 1))
          }}
          className="rounded-full border border-gray-200 p-1.5"
          aria-label={`${label} 인원 줄이기`}
        >
          <Minus size={14} />
        </button>
        <span className="w-4 text-center text-sm font-semibold">{value}</span>
        <button
          type="button"
          onClick={() => {
            onChange(value + 1)
          }}
          disabled={max != null && value >= max}
          className="rounded-full border border-gray-200 p-1.5 disabled:cursor-not-allowed disabled:opacity-30"
          aria-label={`${label} 인원 늘리기`}
        >
          <Plus size={14} />
        </button>
      </div>
    </div>
  )
}
